import moment from 'moment';
import { create } from 'zustand';
import { AnalyticsStore, IAnalyticsContext, IPreviewAnalytic } from '../types/analytics';
import { IEnrichedMetadata } from '../types/metadata';

const useAnalyticsStore = create<AnalyticsStore>((set) => ({
  previewAnalytics: [],
  setPreviewAnalytics: (analytics: IPreviewAnalytic[]) => set({ previewAnalytics: analytics }),

  enrichedMetadata: [],

  setEnrichedMetadata: (enrichedMetadata: IEnrichedMetadata[]) =>
    set((state) => {
      const merged = [...state.enrichedMetadata];
      enrichedMetadata.forEach((entry) => {
        const idx = merged.findIndex(
          (existing) =>
            existing.DatasetId === entry.DatasetId &&
            existing.CoordinatesString === entry.CoordinatesString
        );
        if (idx >= 0) {
          merged[idx] = entry;
        } else {
          merged.push(entry);
        }
      });
      return { enrichedMetadata: merged };
    }),

  analyticsContext: {
    previewDatasetId: '',
    coordinates: [],
    pointName: '',
    categoryDataset: [],
    previewDatasetTimeRange: null,
    onDatasetChange: () => undefined,
  },
  setAnalyticsContext: (context: Partial<IAnalyticsContext>) =>
    set((state) => ({
      analyticsContext: { ...state.analyticsContext, ...context },
    })),

  isForAllAnalytics: false,
  setIsForAllAnalytics: (value: boolean) => set({ isForAllAnalytics: value }),

  globalDateRange: [],
  setGlobalDateRange: (range: moment.Moment[]) => set({ globalDateRange: range }),
}));

export default useAnalyticsStore;
